<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Barcode field</h2>
            <p class="demo-description">
                Assign, preview, and clear a product barcode with <code>upp-barcode-display</code>.
                Use capture mode with a HID scanner or type digits in the listening overlay.
            </p>

            <div class="demo-controls">
                <ion-button size="small" (click)="toggleMode()">Mode: {{ mode }}</ion-button>
                <ion-button size="small" (click)="toggleDisabled()">Disabled: {{ disabled }}</ion-button>
                <ion-button size="small" color="medium" (click)="clearValue()">Clear value</ion-button>
            </div>

            <div class="demo-section" [formGroup]="form">
                <upp-form-section title="Barcode">
                    <upp-barcode-display
                        formControlName="barcode"
                        [mode]="mode"
                    ></upp-barcode-display>
                </upp-form-section>
            </div>
        </div>
    </upp-scrollable>
</div>
